export default function Buy() {
    // TODO: Implement this function
    return <h1>Buy</h1>
}